import React, {
  Component,
} from 'react';
import {
  compose,
} from 'recompose';
import _ from 'lodash';
import PlainHeader from '../../components/plain-header';
import PendingInvitationsList from '../../components/pending-invitations-list';
import withInvitationsData from '../../hocs/data/with-pending-invitations';
import withUserInfo from '../../hocs/has-user-info';

const STATUS_DECLINED = 'DECLINED';

class PendingInvitations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isError: false,
      shouldFetchDeclinedInvitations: true,
      invitations: [],
    };
  }

  componentDidMount = async () => {
    await this.fetchInvitations();
  }

  onInvitationAccepted = invitationId => {
    const invitation = _.find(this.state.invitations, ['id', invitationId]);
    const {
      link,
    } = invitation;
    window.open(link, '_blank');
    const updatedInvitations = _.reject(this.state.invitations, ['id', invitation.id]);
    this.setState({
      invitations: updatedInvitations,
    });
  }

  onInvitationDeclined = async invitationId => {
    const { updateInvitationStatusById } = this.props;
    await updateInvitationStatusById(invitationId, STATUS_DECLINED);
    await this.fetchInvitations();
  }

  onShowDeclinedInvitationsToggleChanged = async (event, data) => {
    const { checked } = data;
    this.setState({
      shouldFetchDeclinedInvitations: checked,
    }, async () => {
      await this.fetchInvitations();
    });
  }

  fetchInvitations = async () => {
    const {
      userInfo: {
        email: userEmail,
      },
      getPendingInvitationsByUserEmail,
    } = this.props;

    const { shouldFetchDeclinedInvitations } = this.state;

    this.setState({
      isLoading: true,
      isError: false,
    });

    const invitations = await getPendingInvitationsByUserEmail(
      userEmail,
      shouldFetchDeclinedInvitations,
    ).catch(this.handleError);

    if (invitations) {
      this.setState({
        isLoading: false,
        isError: false,
        invitations,
      });
    }
  }

  handleError = () => this.setState({
    invitations: null,
    isLoading: false,
    isError: true,
  });

  render = () => (
    <div className="page">
      <div className="padded-content white border-bottom">
        <PlainHeader title="My pending invitations" />
      </div>
      <div className="page-content">
        <PendingInvitationsList
          {...this.state}
          onInvitationAccepted={this.onInvitationAccepted}
          onInvitationDeclined={this.onInvitationDeclined}
          onShowDeclinedInvitationsToggleChanged={this.onShowDeclinedInvitationsToggleChanged}
        />
      </div>
    </div>
  );
}

export default compose(
  withInvitationsData,
  withUserInfo,
)(PendingInvitations);



/** WEBPACK FOOTER **
 ** ./src/containers/pending-invitations/index.js
 **/